<template>
  <div class="flex flex-col">
    <h2>Mascotas</h2>

    <custom-search
      class="mt-2 w-full sm:w-[500px]"
      placeholder="Buscar por Nombre"
      v-model="searchText"
      @confirm="search"
      @clear="search"
    />

    <div class="card mt-6">
      <table class="table-auto text-sm mt-2 bg-white">
        <thead class="text-left">
          <tr class="bg-gray-100">
            <th class="p-2 rounded-l-lg">ID</th>
            <th class="p-2">Nombre</th>
            <th class="p-2">Cliente</th>
            <th class="p-2 rounded-r-lg">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="pet in pets" :key="pet.id" class="table-row">
            <td class="table-cell">
              {{ pet.id }}
            </td>
            <td class="table-cell">
              {{ pet.name }}
            </td>
            <td class="table-cell">
              <router-link
                :to="{
                  name: 'clientsDetail',
                  params: { id: pet.client_id },
                }"
                class="detail-link"
                >{{ pet.client_name }} {{ pet.client_last_name }}</router-link
              >
            </td>
            <td class="table-cell">
              <div class="flex">
                <router-link
                  :to="{
                    name: 'petsDetail',
                    params: { id: pet.id },
                  }"
                  class="secondary-button"
                  >Detalle</router-link
                >
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="loading" class="flex w-full h-full items-center">
        <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
      </div>
    </div>

    <pagination
      :current-page="currentPage"
      :total-pages="totalPages"
      @page-change="onPageChange"
    />
  </div>
</template>

<script>
import api from "@/api";
import Pagination from "@/components/ui/Pagination.vue";
export default {
  name: "Pets",

  components: {
    Pagination,
  },

  data() {
    return {
      pets: null,
      loading: false,
      searchText: "",
      currentPage: 1,
      totalPages: 0,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "pets");

    this.loadPets();
  },

  methods: {
    async loadPets() {
      this.loading = true;

      try {
        const response = await api.pets.getByBranch(
          this.$route.params.branchId,
          [
            {
              name: "page",
              value: this.currentPage,
            },
            {
              name: "search",
              value: this.searchText,
            },
          ]
        );
        this.pets = response.data;
        this.currentPage = response.current_page;
        this.totalPages = response.last_page;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    search() {
      this.currentPage = 1;
      this.loadPets();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.loadPets();
    },
  },
};
</script>